<template>
  <button @click="exportCreditDeposit" class="btn btn-sm btn-info mr-1 mb-1">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop no-enforce-focus ok-only ok-title="Cancel" @ok="close">
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount" :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>

<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  props: ['filter', 'totalCount', 'categoryOptions'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportCreditDeposit: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 1000;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get('/client/', {
          params: params
        });

        let firstOrders = {};
        let ids = result.data.docs.map(item => item._id);
        let firstOrderResult = await this.$service.post('/client/first-plan-order', { ids });
        firstOrderResult.data.forEach(item => firstOrders[item._id] = item);

        params.page += 1;
        response = result.data;
        response.docs.forEach(item => {
          let row;
          if (this.$store.state.user.role === 'marketingManager') {
            row = {
              phone: item.phone
            };
          } else {
            row = {
              code: item.code ? item.code : '',
              client: item.companyName ? item.companyName : '',
              category: item.category ? this.getBusinessCategory(item.category) : '',
              domain: item.domain,
              taxCode: item.taxCode ? item.taxCode : '',
              sales: item.sales ? item.sales.name : '',
              account: item.account ? item.account.name : '',
              email: item.email,
              phone: item.phone,
              host: item.host.ip,
              isTrial: item.isTrial ? this.$t('isTrial') : '',
              active: item.active ? this.$t('active') : this.$t('locked'),
              plan: item.plan ? item.plan.name : this.$t('privatePlan'),
              userCount: item.userCount,
              userLimit: item.userLimit,
              creditBalance: item.creditBalance,
              baseCallFee: item.baseCallFee ? item.baseCallFee : 0,
              createTime: moment(item.createTime).format('DD/MM/YYYY HH:mm:ss'),
              expireTime: moment(item.expireTime).format('DD/MM/YYYY HH:mm:ss'),
              firstOrderTime: firstOrders[item._id] ? moment(firstOrders[item._id].confirmTime).format('DD/MM/YYYY HH:mm:ss') : '',
              firstOrderValue: firstOrders[item._id] ? firstOrders[item._id].total : '',
              firstOrderSale: firstOrders[item._id] && firstOrders[item._id].sales ? firstOrders[item._id].sales.name : '',
              isChatbot: item.isChatbot ? this.$t('yes') : this.$t('no'),
              chatbotTrialTime: item.isChatbot && item.chatbotTrialTime ? moment(item.chatbotTrialTime).format('DD/MM/YYYY HH:mm:ss') : '',
              chatbotExpireTime: item.isChatbot && item.chatbotExpireTime ? moment(item.chatbotExpireTime).format('DD/MM/YYYY HH:mm:ss') : '',
            };
          }
          sheet.addRow(row);
          this.downloadedCount += 1;
        });
      } while (response && response.hasNextPage);
      if (!this.cancelRequest) {
        workbook.xlsx.writeBuffer({base64: true}).then(data => {
          this.exporting = false;
          saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
              'client.xlsx');
        }).finally(() => {
          this.cancelRequest = false;
          this.downloadedCount = 0;
        });
      }
    },
    setupSheet: function (sheet) {
      if (this.$store.state.user.role === 'marketingManager') {
        sheet.columns = [
          {header: this.$t('phone'), key: 'phone', width: 15},
        ];
      } else {
        sheet.columns = [
          {header: this.$t('clientCode'), key: 'code', width: 15},
          {header: this.$t('clientName'), key: 'client', width: 15},
          {header: this.$t('businessCategory'), key: 'category', width: 15},
          {header: 'Domain', key: 'domain', width: 15},
          {header: this.$t('taxCode'), key: 'taxCode', width: 15},
          {header: this.$t('sales'), key: 'sales', width: 15},
          {header: this.$t('account'), key: 'account', width: 15},
          {header: this.$t('email'), key: 'email', width: 15},
          {header: this.$t('phone'), key: 'phone', width: 15},
          {header: this.$t('host'), key: 'host', width: 15},
          {header: this.$t('isTrial'), key: 'isTrial', width: 15},
          {header: this.$t('active'), key: 'active', width: 15},
          {header: this.$t('plan'), key: 'plan', width: 15},
          {header: this.$t('userCount'), key: 'userCount', width: 15},
          {header: this.$t('userLimit'), key: 'userLimit', width: 15},
          {header: this.$t('creditBalance'), key: 'creditBalance', width: 15},
          {header: this.$t('baseCallFee'), key: 'baseCallFee', width: 15},
          {header: this.$t('createTime'), key: 'createTime', width: 15},
          {header: this.$t('expireTime'), key: 'expireTime', width: 15},
          {header: this.$t('firstOrderTime'), key: 'firstOrderTime', width: 15},
          {header: this.$t('firstOrderValue'), key: 'firstOrderValue', width: 15},
          {header: this.$t('firstOrderSale'), key: 'firstOrderSale', width: 15},
          {header: this.$t('isChatbot'), key: 'isChatbot', width: 15},
          {header: this.$t('chatbotTrialTime'), key: 'chatbotTrialTime', width: 15},
          {header: this.$t('chatbotExpireTime'), key: 'chatbotExpireTime', width: 15},
        ];
      }
    },
    close() {
      this.cancelRequest = true;
    },
    getBusinessCategory(type) {
      let result = [this.$t('unknown')];
      if(type && type.length) {
        result = [];
        for(let category of type) {
          let cat = this.categoryOptions.find(c => c.value === category);
          if (cat) result.push(cat.text);
        }
      }
      return result.join(", ");
    },
  },
  i18n: {
    messages: {
      vi: {
        clientName: 'Tên khách hàng',
        host: 'Tổng đài',
        isTrial: 'Dùng thử',
        active: 'Hoạt động',
        locked: 'Bị khóa',
        plan: 'Gói dịch vụ',
        privatePlan: 'Gói đặc biệt',
        userCount: 'Số tài khoản đã tạo',
        userLimit: 'Số tài khoản tối đa',
        creditBalance: 'Số dư tài khoản',
        createTime: 'Tạo lúc',
        expireTime: 'Hết hạn lúc',
        export: 'Xuất dữ liệu',
        taxCode: 'Mã số thuế',
        sales: 'Nhân viên sales',
        account: 'Nhân viên account',
        exportNotice: 'Đợi tí nhóe, đừng tắt cái cửa sổ bé xinh này cho đến khi xong chuyện....',
        baseCallFee: 'Cước nền',
        firstOrderTime: "Mua đơn hàng đầu tiên lúc",
        firstOrderValue: "Giá trị đơn hàng đầu tiên",
        firstOrderSale: "Nhân viên pos đơn hàng đầu tiên",
        companySize: "Số lượng nhân viên",
        clientCode: "Mã khách hàng",
        isChatbot: "Sử dụng nhân viên AI",
        chatbotTrialTime: "Thời gian hết hạn dùng thử nhân viên AI",
        chatbotExpireTime: "Thời gian hết hạn nhân viên AI"
      },
      en: {
        clientName: 'Client name',
        host: 'Host',
        isTrial: 'Trial',
        active: 'Active',
        locked: 'Locked',
        plan: 'Plan',
        privatePlan: 'Private plan',
        userCount: 'User count',
        userLimit: 'User limit',
        creditBalance: 'Credit balance',
        createTime: 'Create time',
        expireTime: 'Expire time',
        export: 'Export',
        taxCode: 'Tax code',
        sales: 'Sales',
        account: 'Account',
        exportNotice: 'Please be patient, data is being exported....',
        baseCallFee: 'Base call fee',
        firstOrderTime: "First order time",
        firstOrderValue: "First order value",
        firstOrderSale: "First order pos person",
        companySize: "Company size",
        clientCode: "Client code",
        isChatbot: "Use AI agent",
        chatbotTrialTime: "AI agent trial expiration time",
        chatbotExpireTime: "AI agent expiration time"
      },
    }
  }
}
</script>
